"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementComponent = void 0;
const core_1 = require("@angular/core");
const connect_organization_1 = require("./connect-organization");
let ConnectManagementComponent = class ConnectManagementComponent {
    reset() {
        this.organization = null;
    }
    reload(organization) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.organization = yield connect_organization_1.ConnectOrganization.get(organization.id);
            }
            catch (err) {
                let errors = yield err.json();
            }
        });
    }
};
exports.ConnectManagementComponent = ConnectManagementComponent;
exports.ConnectManagementComponent = ConnectManagementComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management",
        templateUrl: "app/connect-management.component.html",
        styleUrls: ["styles/connect-management.component.css"]
    }),
    (0, core_1.Injectable)()
], ConnectManagementComponent);
//# sourceMappingURL=connect-management.component.js.map